<template>
    <div class="box-card" style="background-color: #fff">
      <el-scrollbar style="height: 100%">
<!--      <el-row>-->
<!--        <el-col :span="4"><div class="grid-content bg-purple btn">-->
<!--          <span class="el-icon-arrow-left" @click="bk()">返回</span>-->
<!--        </div></el-col>-->
<!--        <el-col :span="20"><div class="grid-content bg-purple-light nav_s">-->
<!--            <span class="el-dropdown-link c1">-->
<!--              销量分析<i class="el-icon-arrow-down el-icon&#45;&#45;right c2"></i>-->
<!--            </span>-->
<!--          <p class="c3">王晓燕</p>-->
<!--        </div></el-col>-->
<!--      </el-row>-->
        <div style="width: 100%;height: 50px;background-color: #fff;line-height: 50px;text-align: center;">
          <div style="color: #4D586D;position: relative">拜访查询<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
            <div class="grid-content bg-purple " style="position: absolute;left: 10px;top: 0px;color: #FF9901">
              <span class="el-icon-arrow-left" @click="bk()">返回</span>
            </div>
          </div>

          <span style="position: relative;top:-31px;font-size: 13px;color: #B0B5B9;"> 王晓燕</span>
        </div>
      <div style="padding: 10px;display: flex;align-items: center;justify-content: space-between">
      <el-select v-model="year" style="width: 80px;margin-right: 10px" placeholder="年份" size="mini">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select><span>年</span>
      <el-select v-model="start_month" style="width: 79px;margin-right: 10px" placeholder="月份" size="mini">
        <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <span style="padding: 0">-</span>
      <el-select v-model="end_month" style="width: 79px;margin-right: 10px" placeholder="月份" size="mini">
        <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <button type="warning" size="mini" @click="nv()" style="background-color: #ff9901;border: 1px solid #ff9901;color: #fff;border-radius: 4px">查询</button>

      </div>
        <div style="width: 100%;text-align: center">
          <el-radio-group v-model="radio" size="mini"
                          fill="#FF9901"
                          @change="nv"
          >
            <el-radio-button label="SKU">按商品</el-radio-button>
            <el-radio-button label="CUSTOMER">按客户</el-radio-button>
          </el-radio-group>
        </div>

      <div v-if="radio=== 'SKU'">
        <div class="ins" style="text-align: center;padding: 10px">
          <el-input prefix-icon="iconfont el-icon-search" class="inputSty" v-model="searchStr"  placeholder="请输入商品名称"
                    size="mini" >
          </el-input>
        </div>
        <el-row >
          <el-col :span="12"><div class="grid-content bg-purple">
            <div class="d1">
              <p style="color: #fff;font-size: 14px;padding-top: 10px;padding-left: 10px ">实现销售额</p>
              <div style="padding: 5px 10px 5px 10px;display: flex;justify-content: space-between;align-items: flex-end">
                <div>
                  <img src="../../assets/images/xiaoshou.png" alt="" width="50px" height="50px">
                </div>
                <div style="color: #fff;padding-bottom: 5px">
                  <span style="font-size: 28px">{{price}}</span> <span>w</span>
                </div>
              </div>
            </div>
          </div></el-col>
          <el-col :span="12"><div class="grid-content bg-purple">
            <div class="d2">
              <p style="color: #fff;font-size: 14px;padding-top: 10px;padding-left: 10px ">动销品规数</p>
              <div style="padding: 5px 10px 5px 10px;display: flex;justify-content: space-between;align-items: flex-end">
                <div>
                  <img src="../../assets/images/dongxiao.png" alt="" width="50px" height="50px">
                </div>
                <div style="color: #fff;padding-bottom: 5px">
                  <span style="font-size: 28px">{{PinNumber}}</span> <span>个</span>
                </div>
              </div>
            </div>
          </div></el-col>
        </el-row>
        <div id="myChat" style=";height: 200px;width: 100%"></div>
        <el-divider class="dr"></el-divider>
        <div style="padding-left: 10px;margin-top: 30px">
          <div style="width: 3px;height: 13px;background-color: #63A9FA"></div>
          <p style="position: relative;margin-top: -15px;margin-left: 5px">本月单品销售金额</p>
          <div class="tex" v-for="(item,value) in option2">
          <el-row :gutter="20">
            <el-col :span="3"><div class="grid-content bg-purple">
              <p class="vl" v-if="value+1=='1'" style="background-color: #DED028;">
                {{value+1}}
              </p>
              <p class="vl" v-else-if="value+1=='2'"  style="background-color: #B6C4E7;">
                {{value+1}}
              </p>
              <p class="vl" v-else-if="value+1=='3'"  style="background-color: #DDBD7D;">
                {{value+1}}
              </p>
              <p class="vl" v-else  style="background-color: #E7F1F9;">
                {{value+1}}
              </p>
            </div></el-col>
            <el-col :span="15"><div class="grid-content bg-purple">
              <p class="a1">{{item.goods_name}}</p>
              <p class="a2">{{item.institution_name}}</p>
            </div></el-col>
            <el-col :span="6"><div class="grid-content bg-purple">
              <p class="a3">{{item.price}}W</p>
            </div></el-col>
          </el-row>
            <div class="dv">
              <el-divider></el-divider>
            </div>

        </div>
        </div>
      </div>
      <div v-else-if="radio=== 'CUSTOMER'">
        <div class="ins" style="text-align: center;padding: 10px">
          <el-input prefix-icon="iconfont el-icon-search" class="inputSty" v-model="searchStr"  placeholder="请输入商品名称"
                    size="mini" >
          </el-input>
        </div>
        <el-row >
          <el-col :span="12"><div class="grid-content bg-purple">
            <div class="d1">
              <p style="color: #fff;font-size: 14px;padding-top: 10px;padding-left: 10px ">实现销售额</p>
              <div style="padding: 5px 10px 5px 10px;display: flex;justify-content: space-between;align-items: flex-end">
                <div>
                  <img src="../../assets/images/xiaoshou.png" alt="" width="50px" height="50px">
                </div>
                <div style="color: #fff;padding-bottom: 5px">
                  <span style="font-size: 28px">{{price}}</span> <span>w</span>
                </div>
              </div>
            </div>
          </div></el-col>
          <el-col :span="12"><div class="grid-content bg-purple">
            <div class="d2">
              <p style="color: #fff;font-size: 14px;padding-top: 10px;padding-left: 10px ">客户动销数</p>
              <div style="padding: 5px 10px 5px 10px;display: flex;justify-content: space-between;align-items: flex-end">
                <div>
                  <img src="../../assets/images/kehus.png" alt="" width="50px" height="50px">
                </div>
                <div style="color: #fff;padding-bottom: 5px">
                  <span style="font-size: 28px">{{PinNumber}}</span> <span>个</span>
                </div>
              </div>
            </div>
          </div></el-col>
        </el-row>
        <div id="myChart1" style=";height: 200px;width: 100%"></div>
        <el-divider  class="dr"></el-divider>
        <div style="padding-left: 10px;margin-top: 30px">
          <div style="width: 3px;height: 13px;background-color: #63A9FA"></div>
          <span class="ke">本月客户销售金额</span>
          <div class="tex" v-for="(item,value) in option2">
            <el-row :gutter="20">
              <el-col :span="3"><div class="grid-content bg-purple">
                <p class="vl" v-if="value=='0'" style="background-color: #DED028;">
                  {{value+1}}
                </p>
                <p class="vl" v-else-if="value=='1'"  style="background-color: #B6C4E7;">
                  {{value+1}}
                </p>
                <p class="vl" v-else-if="value=='2'"  style="background-color: #DDBD7D;">
                  {{value+1}}
                </p>
                <p class="vl" v-else  style="background-color: #E7F1F9;">
                  {{value+1}}
                </p>
              </div></el-col>
              <el-col :span="15"><div class="grid-content bg-purple">
                <p class="a4">{{item.institution_name}}</p>
              </div></el-col>
              <el-col :span="6"><div class="grid-content bg-purple">
                <p>{{item.price}}</p>
              </div></el-col>
            </el-row>
            <div class="dr1">
              <el-divider></el-divider>
            </div>

          </div>
        </div>
      </div>

      </el-scrollbar>
    </div>
</template>

<script>
import echarts from "echarts";
import http from '../../APIService/http'

export default {
 name: "login5",
  data(){
    return{
      year:'',
      start_month:'',
      end_month:'',
      radio:'SKU',
      searchStr:'',
      options: [{
        value: '2018',
        label: '2018'
      },{
        value: '2019',
        label: '2019'
      }, {
        value: '2020',
        label: '2020'
      }, {
        value: '2021',
        label: '2021'
      }, {
        value: '2022',
        label: '2022'
      }],
      options1: [{
        value: '01',
        label: '1月'
      },{
        value: '02',
        label: '2月'
      },{
        value: '03',
        label: '3月'
      },{
        value: '04',
        label: '4月'
      },{
        value: '05',
        label: '5月'
      },{
        value: '06',
        label: '6月'
      },{
        value: '07',
        label: '7月'
      },{
        value: '08',
        label: '8月'
      },{
        value: '09',
        label: '9月'
      },{
        value: '10',
        label: '10月'
      },{
        value: '11',
        label: '11月'
      },{
        value: '12',
        label: '12月'
      }],

      option2:[],
      tenant_id: "1472813523",
      mot:[],
      pre:[],
      PinNumber:"",
      price:""
    }
  },
  mounted() {
      this.nv();
  },
  methods:{


    bk(){
      this.$router.push({path:"/reportIndex"})
    },
    nv(){
      let that = this;
      let forms={
        tenant_id:this.tenant_id,
        start_month:this.start_month,
        end_month:this.end_month,
        type:this.radio,
        searchStr:this.searchStr,
        year:this.year
      }
      that.mot=[]
      that.pre=[]

      http.post('/wapi/gkGetFeedback/GkSalesAnalysis',forms).then(function (res){
        that.option2 = res.data.data.product;
        that.price= res.data.data.price
        that.PinNumber= res.data.data.PinNumber
        let mt =res.data.data.month;
        for(let i=0;i<mt.length;i++){
          let str=mt[i].sales_time.substring(5,7);
          if (str<'10'){
            let str=mt[i].sales_time.substring(6,7);
            that.mot.push(str+'月')
          }else{
            let str=mt[i].sales_time.substring(5,7);
            that.mot.push(str+'月')
          }
          that.pre.push(parseInt(mt[i].price))
        }

        if (that.radio=='SKU') {
          that.Chart()

        }else if (that.radio=='CUSTOMER'){

          that.Chart1()
          console.log(that.radio)
        }

      })
    },
    Chart(){
      let myChart = echarts.init(document.getElementById('myChat'));
      let option = {
        color: ['#3398DB'],
        tooltip: {},
        xAxis: {
          data: this.mot
        },
        yAxis: {},
        series: [{
          name: '销量',
          type: 'bar',
          data: this.pre
        }]
      };
      myChart.setOption(option);
      window.addEventListener('resize',function() {myChart.resize()});
    },
    Chart1(){
      let myChart1 = echarts.init(document.getElementById('myChat1'));
      console.log(this.mot,this.pre)
      let options = {
        color: ['#3398DB'],
        tooltip: {},
        xAxis: {
          data: this.mot
        },
        yAxis: {},
        series: [{
          name: '销量',
          type: 'bar',
          data: this.pre
        }]
      };
      myChart1.setOption(options);
      window.addEventListener('resize',function() {myChart1.resize()});
    },

  },
}
</script>

<style lang="scss" scoped>
  .ke{
    position: absolute;
    margin-top: -15px;
    margin-left: 5px;
  }
  .tex{
    margin-top: 20px;
  }
  .el-progress__text{
    font-size: 14px!important;
    color: #FF9901;
  }
  .inputSty /deep/ span.el-input__prefix{
    left: 110px;

  }
  .inputSty /deep/ .el-input__inner{
    background: #f3f0f0;
    color: black;
    text-align: center;
  }
  .btn{
    padding-top: 10px;
    color: #FF9901;
    font-size: 16px;
  }

  .c1{
    margin-left: 80px;
    padding-top: 13px;
    position: absolute;
    font-size: 18px;
    color: #4D586D;
  }
  .c2{
    color: #b9afaf;
    margin-left: 3px;
    position: absolute;
  }
  .c3{
    color:  #B0B5B9;
    font-size: 13px;
    position: absolute;
    margin-top: 33px;
    margin-left: 100px;
  }
  .vl{
    width: 29px;
    height: 29px;
    border-radius: 50%;
    margin-top: 12px;
    margin-left: 5px;
    text-align: center;
    line-height: 29px;
  }
  .a1{
    font-size: 12px;
  }
  .a2{
    font-size: 11px;
    color: #8D9FA7;
    margin-top: 5px;
  }
  .a3{
    font-size: 16px;
  }
  .a4{
    font-size: 12px;
    margin-top: 20px;
  }
  .dr{
    margin:-10px auto;
  }
  .d1{
    background-color: #2CD0AC;
    width: 100%;
    height: 100px;
  }
  .d2{
    background-color: #FF9901;
    width: 100%;
    height: 100px;
  }
  .el-card__body{
    padding: 0;
    height: 800px;
  }
  .dv{
    margin-top: -15px;
    margin-bottom: -15px;
  }
  .dr1{
    margin-top: -20px;
    margin-bottom: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/gkReport/Sales.vue